export default "__VITE_ASSET__DFIuD2aE__"